export const development = false;

const ipConfig = {
  all: {
    env: development ? "development" : "production",
  },
  development: {
    ip: "http://159.65.152.158:9600/api/v1",
    // ip: 'http://139.59.76.90:9600/api/v1',
    imgServerip: "http://159.65.152.158:9600/api/v1/images",
  },
  production: {
    ip: "https://api.quikpharma.com/api/v1",
    imgServerip: "https://api.quikpharma.com/api/v1/images",
  },
};

export const appConfig = Object.assign(
  ipConfig.all,
  ipConfig[ipConfig.all.env],
);

// Pusher browser credentials are public identifiers, not secrets. The Pusher
// app secret must remain on the backend and must never be added to this project.
export const pusherConfig = {
  key: "c288d78836ac4c765407",
  cluster: "ap2",
};

export const momentDateFormat = "HH:mm ddd MM-DD-YYYY z";
